import React from 'react'
import TextField from '../../../../core/common/textFields/TextField'
import { svgIcons } from '../../../../style/fonts/SvgIcons'
import Select, { StylesConfig } from "react-select";

const IntegrationTab = ({ formik, getallActiveUsers, isReadOnly }: any) => {

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    return (
        <>
            <div className='row' style={{ height: '539px', overflow: 'auto' }}>
                <div className='col-md-4'>
                    <div className='card h-50'>
                        <div className='card-body'>
                            <div className='mb-2'>
                                {svgIcons.LockIcon}
                            </div>
                            <div className='border-gray br-5 h-50'>

                            </div>
                        </div>
                    </div>

                </div>
                <div className='col-md-8'>
                    <div className='card'>
                        <div className='card-body'>

                            <h6 className='mb-2 mt-2'>
                                Feed Stream Details
                            </h6>
                            <>
                                <TextField
                                    label="Feed Stream Type"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    {...formik.getFieldProps("feedStreamType")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Source"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Steam Object Name"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Context"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Context ID"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Object ID"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Record Identifier"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Referrer"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Search Phrase"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Post ID"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Input Device Type"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Stream Operating System"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                            <>
                                <TextField
                                    label="Feed Raw Referrer"
                                    type="text"
                                    icon={svgIcons.LockIcon}
                                    // {...formik.getFieldProps("ctmCallerID")}
                                    disabled
                                />
                            </>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body'>
                            <>
                                <label className='input-label'>Entered By</label>
                                <Select
                                    styles={customStyles}
                                    className="select w-75 "
                                    options={getallActiveUsers?.result?.map((option: any) => ({
                                        label: option?.userName,
                                        value: option?.userId
                                    }))}
                                    value={
                                        formik.values?.lst_EnteredBy
                                            ? {
                                                value: formik.values?.lst_EnteredBy?.id,
                                                label: formik.values?.lst_EnteredBy?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_EnteredBy.id', selectedOption.value);
                                        formik.setFieldValue('lst_EnteredBy.value', selectedOption.label);
                                    }}
                                />
                            </>
                            <>
                                <label className='input-label'>Lead Taker</label>
                                <Select
                                    styles={customStyles}
                                    className="select w-75 "
                                    options={getallActiveUsers?.result?.map((option: any) => ({
                                        label: option?.userName,
                                        value: option?.userId
                                    }))}
                                    value={
                                        formik.values?.lst_LeadTaker
                                            ? {
                                                value: formik.values?.lst_LeadTaker?.id,
                                                label: formik.values?.lst_LeadTaker?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_LeadTaker.id', selectedOption.value);
                                        formik.setFieldValue('lst_LeadTaker.value', selectedOption.label);
                                    }}
                                />
                            </>
                            <>
                                <label className='input-label'>Owner</label>
                                <Select
                                    styles={customStyles}
                                    className="select w-75 "
                                    options={getallActiveUsers?.result?.map((option: any) => ({
                                        label: option?.userName,
                                        value: option?.userId
                                    }))}
                                    value={
                                        formik.values?.lst_Owner
                                            ? {
                                                value: formik.values?.lst_Owner?.id,
                                                label: formik.values?.lst_Owner?.value || '',
                                            }
                                            : null
                                    }
                                    isDisabled={isReadOnly}
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('lst_Owner.id', selectedOption.value);
                                        formik.setFieldValue('lst_Owner.value', selectedOption.label);
                                    }}
                                />
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IntegrationTab